import apiConfig from "constants/apiConfig";
import { NewUser, User, UserListPayload, UserListResponse } from "types/users";
import axiosClient from "utils/axiosClient";

export const fetchUsers = async (hubId: string, payload: UserListPayload): Promise<UserListResponse> => {
    const response = await axiosClient.get(apiConfig.FETCH_USERS.url.replace('<hubId>', hubId), { params: { ...payload } });
    return response.data;
}

export const fetchUser = async (hubId: string, userId: string): Promise<User> => {
    const response = await axiosClient.get(apiConfig.FETCH_USER.url.replace('<hubId>', hubId).replace('<userId>', String(userId)));
    return response.data.user;
}

export const createNewUser = async (hubId: string, payload: NewUser) => {
    const response = await axiosClient.post(apiConfig.CREATE_USER.url.replace('<hubId>', hubId), payload);
    return response.data;
}

export const updateUser = async (hubId: string, userId: string | string, payload: NewUser) => {
    const response = await axiosClient.put(apiConfig.UPDATE_USER.url.replace('<hubId>', hubId).replace('<userId>', String(userId)), payload);
    return response.data;
}

export const fetchUserBrands = async (hubId: string, payload: any = {}) => {
    const response = await axiosClient.get(apiConfig.FETCH_USER_BRANDS.url.replace('<hubId>', hubId), {params: payload});
    return response.data.results;
}

export const fetchRoles = async () => {
    const response = await axiosClient.get(apiConfig.FETCH_ROLES.url);
    return response.data.items;
}

export const deleteUser = async (hubId: string, userId: string | string) => {
    const response = await axiosClient.delete(apiConfig.UPDATE_USER.url.replace('<hubId>', hubId).replace('<userId>', String(userId)));
    return response.data;
}